import { Yii } from "libraries/interfaces/Yii";

export const WORDING : {[key:string]:string}={
    lastName: Yii.t("wui-shared-js", "Nom"),
    firstName: Yii.t("wui-shared-js", "Prénom"),
    identityCardCitizenship: Yii.t("wui-shared-js", "Nationalité"),
    passportCitizenship: Yii.t("wui-shared-js", "Nationalité"),
    passCountry: Yii.t("wui-shared-js", "Pays d'émission"),
    cardCountry: Yii.t("wui-shared-js", "Pays d'émission"),
    passNumber: Yii.t("wui-shared-js", "N. de passeport"),
    cardNumber: Yii.t("wui-shared-js", "N. de carte d'identité"),
};
